import _ from 'lodash';
import { history } from 'umi';
import { stringify } from 'qs';
import { generatePath } from 'react-router';

const routes = {
  'app.user.login': {
    path: '/user/login',
  },
};

const resolveRoutes = (umiRoutes, prevName) => {
  let nextPrevName = '';
  _.forEach(umiRoutes, (route) => {
    const { name, path, params = {} } = route;

    if (prevName) {
      nextPrevName = `${prevName}.${name}`;
    } else {
      nextPrevName = name;
    }

    if (name && path) {
      routes[nextPrevName] = _.omit(route, ['component']);
      routes[nextPrevName].name = nextPrevName;
    }

    if (route.routes) {
      resolveRoutes(route.routes, nextPrevName);
    }
  });
};

const path = (name, options = {}) => {
  const pattern = _.get(routes, [name, 'path']);
  const url = generatePath(pattern, options);
  const { params } = options;

  if (!params) {
    return url;
  }

  return `${url}?${stringify(params, { arrayFormat: 'brackets' })}`;
};

const getQuery = () => {
  const {
    location: { query },
  } = history;

  return query;
};

const genRedirect = () => {
  const {
    location: { search = '', pathname },
  } = history;

  let redirect = pathname;

  if (search && !search.startsWith('?')) {
    redirect += '?' + search;
  } else {
    redirect += search;
  }

  return redirect;
};

const redirectToLogin = (isTrue = true) => {
  if (!isTrue) {
    return false;
  }

  const redirect = genRedirect();

  history.push({
    pathname: path('app.user.login'),
    query: {
      redirect,
    },
  });

  window.location.reload(true);

  return true;
};

const getPageName = (path) => {
  return _.chain(routes)
    .filter((item) => item.path === path)
    .last()
    .value()?.name;
};

export default {
  path,
  genRedirect,
  getQuery,
  getPageName,
  resolveRoutes,
  redirectToLogin,
  routes,
};
